// extracted by mini-css-extract-plugin
export default {"start":"LaunchGame_start__l7awr","button":"LaunchGame_button__lCftU"};